import { render, staticRenderFns } from "./ItemClassificationList.vue?vue&type=template&id=fe30215c&"
import script from "./ItemClassificationList.vue?vue&type=script&lang=js&"
export * from "./ItemClassificationList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports